import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonReorderDialog } from 'components/common/dialogs/reorder';
import usePitchListStore from 'components/sections/pitch-list/store/use-pitch-list-store';
import { IOption } from 'lib_ts/interfaces/common/i-option';
import { IPitch } from 'lib_ts/interfaces/pitches';
import { useState } from 'react';
import { MainService } from 'services/main.service';
import useListLibraryStore from 'stores/use-list-library-store';

interface IProps {
  pitches: IPitch[];
  onClose: () => void;
}

export const ReorderDialog = (props: IProps) => {
  const [loading, setLoading] = useState(false);

  const activeList = useListLibraryStore((s) => s.activeList);

  const items: IOption[] = props.pitches.map((p) => ({
    value: p._id,
    label: p.name || '',
  }));

  return (
    <CommonReorderDialog
      identifier="ReorderDialog"
      items={items}
      onReorder={async (options) => {
        if (options.length !== items.length) {
          NotifyHelper.error({
            message_md: `Invalid result from reorder operation, expected ${items.length} items but received ${options.length} instead.`,
          });
          return;
        }

        try {
          setLoading(true);

          await MainService.getInstance().updateOrder({
            collection: 'pitches',
            ids: options.map((m) => m.value),
          });

          await usePitchListStore.getState().reloadPitches({
            activeList,
          });

          NotifyHelper.success({ message_md: 'Sort order saved' });
          props.onClose();
        } catch (error) {
          NotifyHelper.error({
            message_md: 'An error occurred while reordering your list',
          });
        } finally {
          setLoading(false);
        }
      }}
      loading={loading}
      onClose={props.onClose}
    />
  );
};
